export const KOMISI_ALL_CABANG_GET_REQUEST = "KOMISI_ALL_CABANG_GET_REQUEST";
export const KOMISI_ALL_CABANG_GET_SUCCESS = "KOMISI_ALL_CABANG_GET_SUCCESS";
export const KOMISI_ALL_CABANG_GET_FAIL = "KOMISI_ALL_CABANG_GET_FAIL";
export const KOMISI_ALL_CABANG_GET_RESET = "KOMISI_ALL_CABANG_GET_RESET";
